<style lang="less">
@import "../../../styles/table.less";
.importStep {
  padding: 40px 0;
  .importBar {
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    margin: 20px 0;
    .iconSide {
      width: 200px;
    }
    .detailSide {
      flex: 1;
      padding: 10px 0;
      .title {
        font-size: 24px;
        line-height: 42px;
      }
      .detail {
        color: #999;
        line-height: 36px;
      }
    }
  }
}
.el-input {
  width: 300px;
}
</style>
<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70">
              <Form-item label="订单号" prop="id">
                <Input
                  type="text"
                  v-model="searchForm.id"
                  placeholder="输入订单号"
                  clearable
                  style="width: 200px"
                />
              </Form-item>
              <Form-item label="姓名" prop="userName">
                <Input
                  type="text"
                  v-model="searchForm.userName"
                  placeholder="输入名称"
                  clearable
                  style="width: 200px"
                />
              </Form-item>
              <Form-item label="联系方式" prop="mobile">
                <Input
                  type="text"
                  v-model="searchForm.mobile"
                  placeholder="输入联系方式"
                  clearable
                  style="width: 200px"
                />
              </Form-item>
              <span v-if="drop">
                <Form-item label="支付方式" prop="payType">
                  <Select
                    v-model="searchForm.payType"
                    placeholder="请选择支付方式"
                    clearable
                    style="width: 200px"
                  >
                    <Option value="Alipay">支付宝</Option>
                    <Option value="WxPay">微信</Option>
                    <Option value="Balance">学习币</Option>
                  </Select>
                </Form-item>
                <Form-item label="创建时间">
                  <DatePicker
                    v-model="selectDate"
                    type="daterange"
                    split-panels
                    format="yyyy-MM-dd"
                    clearable
                    @on-change="selectDateRange"
                    placeholder="选择起始时间"
                    style="width: 200px"
                  ></DatePicker>
                </Form-item>
              </span>
              <Form-item style="margin-left: -35px" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search"
                  >搜索</Button
                >
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown"
                  >{{ dropDownContent }}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="exportData" icon="md-trash">导出</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
            <el-dropdown @command="appendStudent">
              <el-button type="primary" size="small">
                添加考生<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="true">手动添加</el-dropdown-item>
                <el-dropdown-item :command="false">批量导入</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <circleLoading v-if="operationLoading" />
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{ selectCount }}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table
              :loading="loading"
              border
              :columns="columns"
              :data="data"
              sortable="custom"
              @on-sort-change="changeSort"
              @on-selection-change="showSelect"
              ref="table"
            ></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page
              :current="searchForm.pageNumber"
              :total="total"
              :page-size="searchForm.pageSize"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
              :page-size-opts="[10, 20, 50]"
              size="small"
              show-total
              show-elevator
              show-sizer
            ></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <el-dialog
      title="批量导入"
      :visible.sync="editStudentData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-form
        ref="form"
        size="small"
        :model="editStudentData"
        label-width="120px"
      >
        <el-form-item label="姓名：" required>
          <el-input v-model="editStudentData.userName" placeholder="姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="公司名称：">
          <el-input v-model="editStudentData.company" placeholder="公司名称">
          </el-input>
        </el-form-item>
        <el-form-item label="性别：" required>
          <el-radio v-model="editStudentData.sex" :label="1">女</el-radio>
          <el-radio v-model="editStudentData.sex" :label="2">男</el-radio>
        </el-form-item>
        <el-form-item label="手机号码：" required>
          <el-input v-model="editStudentData.mobile" placeholder="手机号码">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号：" required>
          <el-input v-model="editStudentData.idCard" placeholder="身份证号">
          </el-input>
        </el-form-item>
        <el-form-item label="会员有效期：" required>
          <el-date-picker
            size="mini"
            v-model="editStudentData.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd"
            @change="
              (val) => {
                [editStudentData.startTime, editStudentData.endTime] = val;
              }
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitStudentForm">提交</el-button>
          <el-button
            @click="
              Object.assign(editStudentData, $options.data().editStudentData, {
                ifShow: true,
              })
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="批量导入"
      :visible.sync="importData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-steps :active="importData.step">
        <el-step title="上传文件"></el-step>
        <el-step title="执行导入"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div class="importStep" v-show="importData.step == 0">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">填写导入教师的信息</div>
            <div class="detail">
              请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
            </div>
            <div>
              <!-- <a href="/public/企业学员导入模板.xlsx" icon="md-album"
                >下载模板</a
              > -->

              <el-button
                type="text"
                size="mini"
                @click="download('../会员导入模板.xlsx')"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">上传填好的教师信息表</div>
            <div class="detail">
              文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M
            </div>
            <div>
              <el-upload
                :on-change="uploadChange"
                action="/base/common/importIndividualMember"
                :data="importData"
                :file-list="importData.fileList"
                :on-success="importSuccess"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-remove="
                  () => {
                    importData.fileList = [];
                  }
                "
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button type="text" size="mini">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="importStep" v-show="importData.step == 1">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次可导入数量</div>
            <div>
              <el-button type="text">{{ importData.successNum }}人</el-button>
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次不可导入数量</div>
            <div>
              <el-button type="text">{{ importData.failNum }}人</el-button>
            </div>
          </div>
        </div>
        <h3 v-if="importData.failNum > 0">不可导入列表</h3>
        <el-table
          v-if="importData.failNum > 0"
          :data="importData.failList"
          border
          style="width: calc(100% - 40px); margin: 20px"
        >
          <el-table-column
            prop="userName"
            label="行数"
            type="index"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="120">
          </el-table-column>

          <el-table-column prop="mobile" label="手机" width="200">
          </el-table-column>
          <el-table-column prop="failMsg" label="错误提示" min-width="300">
          </el-table-column
        ></el-table>
      </div>
      <div class="importStep" v-show="importData.step == 2">
        <h1 style="text-align: center">批量导入完成</h1>
        <h3 style="text-align: center">
          成功导入教师数量:{{ importData.successNum }}人
        </h3>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="importData.step++"
          v-if="importData.step == 0"
          :disabled="!importData.fileList[0]"
          >下一步</el-button
        >
        <el-button
          type="primary"
          @click="doImportStudentIntoCourse"
          v-if="importData.step == 1"
          >提交并执行</el-button
        >
        <el-button
          type="primary"
          @click="importData.step = 0"
          v-if="importData.step == 1"
          plain
          >返回重新上传</el-button
        >
        <el-button
          type="primary"
          @click="importData.ifShow = false"
          v-if="importData.step == 2"
          >完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import circleLoading from "../../my-components/circle-loading.vue";
import {
  orderList,
  delOrder,
  importVipUserExcel,
  createVipMember,
} from "@/api/bus";
import Util from "@/libs/util";
export default {
  name: "vipuser-manage",
  components: {
    circleLoading,
  },
  data() {
    return {
      loading: false, // 表单加载状态
      operationLoading: false,
      drop: false,
      selectCount: 0, // 多选计数
      selectList: [], // 多选数据
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: {
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "createTime", // 默认排序字段
        order: "desc", // 默认排序方式
        id: "",
        payType: "",
        orderEntity: "vip",
        userName: "",
        targetId: 1,
        mobile: "",
        startDate: "",
        endDate: "",
      },
      selectDate: null, //选择日期绑定modal
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          type: "index",
          width: 60,
          align: "center",
        },

        {
          title: "订单号",
          key: "id",
          width: 200,
          sortable: true,
        },
        {
          title: "姓名",
          key: "userName",
          width: 200,
          sortable: true,
        },
        {
          title: "昵称",
          key: "nickName",
          width: 200,
          sortable: true,
        },
        {
          title: "联系方式",
          key: "mobile",
          width: 200,
          sortable: true,
        },
        {
          title: "头像",
          key: "avatar",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("Avatar", {
              props: {
                src: params.row.avatar,
              },
            });
          },
        },
        {
          title: "支付状态",
          key: "payStatusText",
          width: 120,
          align: "center",
          sortable: true,
        },
        {
          title: "支付方式",
          key: "payTypeText",
          width: 180,
          sortable: true,
        },
        {
          title: "支付金额",
          key: "orderAmount",
          width: 180,
          sortable: true,
        },
        {
          title: "支付日期",
          key: "payDate",
          width: 180,
          sortable: true,
        },
      ],
      importData: {
        ifShow: false,
        isExecute: 0,
        importFile: null,
        fileList: [],
        failList: [],
        step: 0,
        failNum: 0,
        successNum: 0,
      },
      data: [], // 表单数据
      total: 0, // 表单数据总数
      editStudentData: {
        ifShow: false,
        userName: "",
        mobile: "",
        idCard: "",
        startTime: "2022-07-01  11：00：00",
        endTime: " 2022-07-01 11：00：00 ",
        sex: 1, // 1女 2男
        company: "",
        timeRange: [],
      },
    };
  },
  methods: {
    submitStudentForm() {
      createVipMember(this.editStudentData).then((data) => {
        console.log(data);
        this.$message.success(data);
        this.editStudentData.ifShow = false;
        this.init();
      });
    },
    init() {
      this.getDataList();
    },
    getDataList() {
      this.loading = true;
      orderList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.status === true) {
          this.data = res.data.rows;
          this.total = res.data.total;
        }
      });
    },
    doImportStudentIntoCourse() {
      let formData = new FormData();
      formData.append("file", this.importData.fileList[0]);
      formData.append("isExecute", 1);
      console.log(formData);
      importVipUserExcel(formData).then((data) => {
        this.importData.step = 2;
        this.getDataList();
      });
    },
    uploadChange(e) {
      if (e.percentage == 100) {
        this.importData.fileList = [e.raw];
      }
    },
    importSuccess(response, file, fileList) {
      this.importData.importFile = file;
      Object.assign(this.importData, response.data);
    },

    appendStudent(ifSingle) {
      if (ifSingle) {
        Object.assign(
          this.editStudentData,
          this.$options.data().editStudentData,
          {
            ifShow: true,
          }
        );
      } else {
        Object.assign(this.importData, this.$options.data().importData);
        this.importData.ifShow = true;
      }
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    exportData() {
      window.location.href = Util.initUrl(
        "/base/common/uservip_export",
        this.searchForm
      );
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    showSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    add() {},
    edit(v) {},
    remove(v) {},
    delAll() {},
    download(url) {
      location.href = url;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
